import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "sub-title" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdButton',
    props: {
        topicon: {},
        bottomrighticon: {},
        title: {},
        subtitle: {},
        href: {}
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function handleClick(e) {
            if (!props.href) {
                e.preventDefault();
            }
            emit('click', e);
        }
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("a", {
                href: _ctx.href != null ? _ctx.href : 'javascript:void(0)',
                onClick: handleClick
            }, [
                _createElementVNode("div", {
                    class: "ad-button",
                    style: _normalizeStyle('background-image:url(' + _ctx.bottomrighticon + ')')
                }, [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "icon-col v-col-1" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("img", { src: _ctx.topicon }, null, 8, _hoisted_2)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { class: "title-col" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "subtitle-col v-col-9" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.subtitle), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ], 4)
            ], 8, _hoisted_1));
        };
    }
});
